export default __webpack_public_path__ + "static/media/cyberlotus-icon.12b86d61.png";